import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './EventContainer.module.scss';
import userStyles from './User.module.scss';

import EventPreview from './EventPreview';

const EventContainer = (props) => {
  const { t } = useTranslation(['users']);
  const types = props.isOrg ? ['hosted'] : ['attended', 'hosted'];
  const onEventDelete = props.onEventDelete;
  const tabLabels = { 
    hosted: t('users:profile.events.tabs.hosting'), 
    attended: t('users:profile.events.tabs.attending') 
  };

  const [activeTab, setActiveTab] = useState(types[0]);

  const detectScrollable = () => {
    const eventList = document.getElementById('eventList');
    return eventList.scrollHeight > eventList.clientHeight;
  };

  const [isScrollable, setScrollable] = useState(false);

  useEffect(() => {
    if (props[activeTab].length > 0) {
      setScrollable(detectScrollable());
    }
  }, [activeTab]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tabHeader} data-cy="user-events">
        {types.map((eventType) => (
          <div
            key={eventType}
            className={cn(styles.tab, {
              [styles.active]: eventType === activeTab
            })}
            onClick={() => setActiveTab(eventType)}
          >
            {tabLabels[eventType].toUpperCase()}
          </div>
        ))}
        <div className={cn(styles.placeholder, styles.tab)} />
      </div>
      {props[activeTab].length > 0 ? (
        <div
          className={cn(styles.tabContainer, {
            [styles.scrollable]: isScrollable
          })}
          id="eventList"
        >
          {props[activeTab].map((event, i) => (
            <EventPreview key={i} event={event} onEventDelete={onEventDelete} />
          ))}
        </div>
      ) : (
        <div className={cn(userStyles.private, styles.private)}>
          {t('users:profile.events.empty')}
        </div>
      )}
    </div>
  );
};

export default EventContainer;
